import React from 'react';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SortBy = (props) => {
    return(
        <div className="sort-by">
            <div className="sort-by__title" onClick={props.handleOpenSortModal} onKeyDown={props.handleOpenSortModal} tabIndex="0">
                {i18next.t("SORT_BY")}
                <FontAwesomeIcon className="sort-by__title-icon" icon="angle-down" />
            </div>
            <div className="sort-by__fade" onClick={props.handleOpenSortModal}></div>
            <ul className="sort-by__options">
                <li className="sort-by__option">
                    <label>
                        <input type="radio" name="sortBy" value="price-asc" onClick={props.handleSortByChange} />
                        {i18next.t("SORT_PRICE_ASC")}
                    </label>
                </li>
                <li className="sort-by__option">
                    <label>
                        <input type="radio" name="sortBy" value="price-desc" onClick={props.handleSortByChange} />
                        {i18next.t("SORT_PRICE_DESC")}
                    </label>
                </li>
                <li className="sort-by__option">
                    <label>
                        <input type="radio" name="sortBy" value="name-asc" onClick={props.handleSortByChange} />
                        {i18next.t("SORT_NAME_ASC")}
                    </label>
                </li>
                <li className="sort-by__option">
                    <label>
                        <input type="radio" name="sortBy" value="name-desc" onClick={props.handleSortByChange} />
                        {i18next.t("SORT_NAME_DESC")}
                    </label>
                </li>
            </ul>
        </div>
    );
}

export default SortBy;